import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=fb4175c6&scoped=true&"
import script from "./orgTree.vue?vue&type=script&lang=js&"
export * from "./orgTree.vue?vue&type=script&lang=js&"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=fb4175c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4175c6",
  null
  
)

export default component.exports